module.exports = __webpack_public_path__ + "static/media/equal_to.2730b6ed.svg";